import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/fund/icon_circle.png'
import _imports_1 from '@/assets/image/fund/icon_lock_paypal.png'
import _imports_2 from '@/assets/image/fund/icon_success.png'


const _withScopeId = n => (_pushScopeId("data-v-f08ee120"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "paypal-pay-modal"
}
const _hoisted_2 = { class: "paypal-pay-container" }
const _hoisted_3 = { class: "credit-card-pay-loading" }
const _hoisted_4 = {
  key: 0,
  class: "loading-img"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "animation"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "",
    class: "abs lock-icon"
  })
], -1))
const _hoisted_6 = { class: "credit-card-pay-loading-title" }
const _hoisted_7 = { class: "credit-card-pay-loading-text" }
const _hoisted_8 = {
  key: 1,
  class: "loading-img",
  style: {"margin-top":"-10px"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "",
    style: {"width":"160px","margin-left":"10px"}
  })
], -1))
const _hoisted_10 = { class: "credit-card-pay-loading-title" }
const _hoisted_11 = { class: "credit-card-pay-loading-text" }

import { t } from '@/plugins/i18n'

import { ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  // loading 加载中 success 成功
  type: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props


return (_ctx: any,_cache: any) => {
  return (__props.type)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (__props.type === 'loading')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('支付中，请稍等')), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('由PayPal提供服务')), 1)
                ]))
              : _createCommentVNode("", true),
            (__props.type === 'success')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('支付成功')), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('由PayPal提供服务')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})